import type { RxDocument } from 'rxdb';
import { useParams } from 'react-router-dom';

import { useDocuMenu } from '@/hooks/use-docu-menu';
import { useItemActions } from '@/hooks/use-item-actions';

import { NewTagPopover } from '@/components/new-tag-popover';
import { Icon } from '@flintmint/web-shared/components/icon';
import { Button } from '@flintmint/web-shared/components/button';
import { WorkspaceSidebarList } from '@/features/workspace-sidebar';
import { InitialSyncBanner } from '@/components/initial-sync-banner';

import { tagsNoDataDescriptions } from '@/constants/ui';
import { searchFilterKey } from '@/constants/search-filters';

import type { Tag } from '@flintmint/core-shared/rxdb';

export const Tags = () => {
  const { tagId } = useParams();

  const { openDocument } = useItemActions();
  const menuData = useDocuMenu(['select', 'delete']);

  const onTagCreate = (newTag: RxDocument<Tag>) => {
    openDocument({ ...newTag.toJSON(), type: 'tags' });
  };

  return (
    <WorkspaceSidebarList
      searchParamKey={searchFilterKey}
      getSearchableTypes={() => ['tags']}
      getNoDataConfig={() => ({
        icon: 'note-bulk',
        descriptions: tagsNoDataDescriptions,
        defaultActionRenderer: () => (
          <NewTagPopover
            placement="top"
            offset={[0, 10]}
            onTagCreate={onTagCreate}
            colorPickerProps={{
              placement: 'top',
              offset: [0, 26],
            }}
          >
            <Button icon={<Icon size={20} type="plus" />}>New Tag</Button>
          </NewTagPopover>
        ),
      })}
      renderActions={() => (
        <NewTagPopover onTagCreate={onTagCreate}>
          <Icon size={20} type="plus" data-testid="left-sidebar-plus-btn" />
        </NewTagPopover>
      )}
      docuListProps={{
        mode: 'tag',
        menu: menuData,
        showDate: false,
        defaultSize: 50,
        'data-testid': 'tags',
        hasFilters: false,
        showDescription: false,
        activeDocumentId: tagId,
        searchableTypes: ['tags'],
        selections: tagId ? [{ id: tagId }] : [],
        listHeader: <InitialSyncBanner />,
      }}
    />
  );
};
